// read the url to see what env we're running on
export default (urlHost = window.location.host) => {
  if (urlHost.match(/^(?:proxy\.)?netconn\.dev\.gogoair/)) return 'development';
  if (urlHost.match(/^(?:proxy\.)?netconn\.stage\.gogoair/)) return 'stage';
  if (urlHost.match(/^(?:proxy\.)?netconn\.(?:prod\.)?gogoair/)) return 'production';
  return 'localhost';
};
